<div class="g-info-page">
  <p [innerHTML]="'account_discount.content_1' | translate"></p>
  <p [innerHTML]="'account_discount.content_2' | translate"></p>
  <p [innerHTML]="'account_discount.content_3' | translate"></p>
  <p [innerHTML]="'account_discount.content_4' | translate"></p>
  <h2 [innerHTML]="'account_discount.content_5' | translate"></h2>
  <p>
    {{ 'account_discount.finished_orders_count' | translate }} -
    <strong>{{ customerService.customer()?.totalOrdersCount ?? 0 }}</strong><br>
    {{ 'account_discount.items_cost' | translate }}
    <strong>{{ customerService.customer()?.totalOrdersCost ?? 0 }}</strong>
    {{ 'global.uah' | translate }}
  </p>
</div>
